import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_PAYMENT_METHOD } from '@/utils/api-url'
import {
  notificationDanger,
  notificationSuccess
} from '@/utils/notification'

const state = () => {
  return {
    payment_method: { data: [] },
    detail_payment_method: {},
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loading: false
    },
    toggle_modal_export: {
      targetModals: false,
      title: '',
      message: '',
      buttonText: '',
      loading: false
    }
  }
}

const mutations = {
  SET_PAYMENT_METHOD (state, payload) {
    state.payment_method = payload
  },
  SET_DETAIL_PAYMENT_METHOD (state, payload) {
    state.detail_payment_method = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_FILE_EXPORT (state, payload) {
    state.file_export = payload
  },
  SET_TOGGLE_MODAL_EXPORT(state, payload) {
    state.toggle_modal_export = payload
  }

}

const actions = {
  async getPaymentMethodList (context, payload) {
    try {
      const response = await apiGetAuth(API_PAYMENT_METHOD.LIST_PAYMENT_METHOD, payload)
      context.commit('SET_PAYMENT_METHOD', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailPaymentMethod (context, payload) {
    try {
      const response = await apiGetAuth(API_PAYMENT_METHOD.DETAIL_PAYMENT_METHOD(payload))
      context.commit('SET_DETAIL_PAYMENT_METHOD', response.data.data)
      return response.data.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updatePaymentMethod (context, payload) {
    try {
      const response = await apiPutAuth(API_PAYMENT_METHOD.UPDATE_PAYMENT_METHOD(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async sortingPaymentMethod (context, payload) {
    try {
      const response = await apiPutAuth(API_PAYMENT_METHOD.SORTING_PAYMENT_METHOD, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
      
      throw error
    }
  },
  async getFileExport (context ) {
    try {
      const response = await apiGetAuth(API_PAYMENT_METHOD.EXPORT_PAYMENT_METHOD )
      if(response?.status == 200) {
        context.commit('SET_TOGGLE_MODAL_EXPORT', {
          targetModals: true,
          title: 'Export Requested',
          message: response.data.message || 'Mohon tunggu, Link download file akan dikirim ke email anda',
          buttonText: 'OK',
          loading: false
        })

        notificationSuccess("Export Requested")
      }
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
      
      throw error
    }
  }
}

const getters = {
  payment_method (state) {
    return state.payment_method
  },
  detail_payment_method (state) {
    return state.detail_payment_method
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_file_export (state) {
    return state.file_export
  },
  get_toggle_modal_export(state) {
    return state.toggle_modal_export
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
